export const CREATION_TYPE = {
  WALDOGRAM: 'WALDOGRAM',
  COLLAGE: 'COLLAGE',
  CAMPERGRAM: 'CAMPERGRAM',
};
